import { getLanguageFromLangCode } from "@arcteryx/js-language";

export const buildAlgoliaIndex = ({
  environment = "prod", // prod or preprod
  market = "outdoor", // outdoor, sale (outlet) or leaf
  country = "ca",
  language = "en",
}) => {
  const lang = getLanguageFromLangCode(language).toLowerCase();
  return `${environment}_arcteryx_product_${market}_${country.toLowerCase()}_${lang}`;
};
